export default {
  title: {
    baseInfo: '基础信息',
    education: '教育背景',
    workExperience: '工作经验',
    partTimeExperience: '实习 / 兼职经验',
    additionalInfo: '附加信息',
    language: '语言能力'
  },
  label: {
    myProfile: '我的档案',
    legalName: '姓名',
    homeLocation: '户口所在地',
    currentLocation: '当前所在地',
    email: '邮箱地址',
    mobileId: '手机帐号',
    address: '地址',
    salutation: '称谓',
    otherAddress: '其他地址（如果有）',
    birthday: '出生日期',
    phone: '手机号码',
    gender: '性别',
    secondPhone: '其他手机号码',
    chatId: '在线聊天工具',
    socialNetwork: '社交网络',
    expectedSalary: '期望薪资',
    school: '毕业学校',
    degreeAndMajor: '学历和专业',
    date: '日期',
    now: '现在',
    companyName: '公司名称',
    jobTitle: '职位名称',
    industry: '行业',
    location: '所在地',
    salary: '薪资',
    description: '职务描述',
    professionalMemberShip: '社团组织成员',
    awards: '奖励信息',
    hobbies: '兴趣爱好',
    language: '工作语言',
    Mr: '先生',
    Mrs: '夫人',
    Ms: '女士',
    dates: {
      years: '{num} 年',
      months: '{num} 月',
      days: '{num} 天',
      year: '{num} 年',
      month: '{num} 月',
      day: '{num} 天'
    },
    editResume: '编辑'
  },
  btn: {
    viewProfile: '查看信息',
    viewResume: '查看简历',
    finishProfile: '请完善您的个人信息'
  }
}
